/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Industry } from '../../lib/wwg.classes';

@Component({
  selector: 'wwg-industry',
  templateUrl: './industry.component.html',
  styleUrls: ['./industry.component.scss']
})
export class IndustryComponent {

  private _model: Industry;

  @Input() get model() {
    return this._model;
  }
  @Output() modelChange = new EventEmitter();

  set model(val) {
    this._model = val;
    this.modelChange.emit(this._model);
  }

  keys(): string[] {
    return Object.keys(this._model);
  }

  levels(props): string[] {
    return Object.keys(props);
  }

  public addIndustry() {
    if (!this.model) {
      this.model = Industry.withEmptyValues();
    }
  }
}
